import { postGateway } from "@/request";

export function setCart(merchantId, list) {
    if(list.length) {
        localStorage.setItem("cart-" + merchantId, JSON.stringify(list));
    }
}

export function removeCart(merchantId) {
    localStorage.removeItem("cart-" + merchantId);

    if (!localStorage.getItem('clientId')) {
        return
    }
    let param = {
        merchantId: merchantId * 1,
        clientId: localStorage.getItem('clientId')
    }
    postGateway({
            url: '/customerApp/cart/cleanCart',
            data: param
        })
        .then(res => {
            console.log(res, '清除购物车成功')
        })
        .catch(err => {
            console.log(err, '清除购物车失败')
        })
}

export function getCart(merchantId) {
    let result = [];
    if (localStorage.getItem("cart-" + merchantId)) {
        result = JSON.parse(localStorage.getItem("cart-" + merchantId))
    }
    return result
}

/**
 * 购物车行内 subItem 合并 key（与后端是否回传 sortIndex 无关，用于把本地客户端字段补回）
 */
export function cartSubItemMergeKey(s) {
    if (!s || typeof s !== 'object') return ''
    return [
        s.subCatId,
        s.subItemId,
        s.splitSlotIndex,
        s.splitBaseAddonCatId,
        s.splitSlotTitle
    ]
        .map(x => (x !== undefined && x !== null ? String(x) : ''))
        .join('|')
}

/**
 * 将上一版 subItems 上的客户端字段（如 sortIndex、allowSplit）合并进接口返回的 subItems
 */
export function mergeSubItemsPreserveClientFields(prevSubs, nextSubs, fields) {
    const keys = fields && fields.length ? fields : ['sortIndex', 'allowSplit']
    if (!Array.isArray(nextSubs) || !nextSubs.length) return nextSubs
    if (!Array.isArray(prevSubs) || !prevSubs.length) return nextSubs
    const map = new Map()
    prevSubs.forEach(s => {
        map.set(cartSubItemMergeKey(s), s)
    })
    return nextSubs.map(s => {
        const p = map.get(cartSubItemMergeKey(s))
        if (!p) return s
        const out = { ...s }
        keys.forEach(f => {
            if ((out[f] === undefined || out[f] === null) && p[f] !== undefined && p[f] !== null) {
                out[f] = p[f]
            }
        })
        return out
    })
}

/**
 * getBatMerchantCart 等接口用 list 覆盖本地购物车时会丢掉 subItems 上的 sortIndex/allowSplit，用上一版 cart 按行合并补回
 */
export function mergeCartListPreserveSubItemMeta(prevList, nextList) {
    if (!Array.isArray(nextList) || !nextList.length) return nextList
    if (!Array.isArray(prevList) || !prevList.length) return nextList
    return nextList.map(nLine => {
        const pLine =
            prevList.find(
                p =>
                    p &&
                    nLine &&
                    String(p.itemId) === String(nLine.itemId) &&
                    String(p.chooseItems || '') === String(nLine.chooseItems || '')
            ) || prevList.find(p => p && nLine && String(p.itemId) === String(nLine.itemId))
        if (!pLine) return nLine
        const base = { ...nLine }
        if (
            (base.allowSplit === undefined || base.allowSplit === null) &&
            pLine.allowSplit !== undefined &&
            pLine.allowSplit !== null
        ) {
            base.allowSplit = pLine.allowSplit
        }
        if (!Array.isArray(nLine.subItems)) return base
        return {
            ...base,
            subItems: mergeSubItemsPreserveClientFields(pLine.subItems, nLine.subItems, [
                'sortIndex',
                'allowSplit',
                'addonCategory',
                'splitSlotTitle',
                'splitSlotIndex',
                'splitBaseAddonCatId',
                'splitBranchType'
            ])
        }
    })
}